module.exports = __webpack_public_path__ + "static/media/LK.0accfa8a.svg";